<template>
          <Tables class="Table-Info" ref="tableGrid"
              :columns="['Corretor', 'Empreendimento', 'Dt. da Venda', 'Valor Total', 'Comissão', 'Formas de Pagamento', 'Nº de Parcelas', 'Parcelas Quitadas', '']"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              v-on:Load="onLoad"
            >
              <tr v-for="comissao in consultacomissao" v-bind:key="comissao.id">
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.conta.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.empreendimento.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.dataVendaFormatada" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.proposta.valorTotalFormatado == 0 ? '0' :comissao.proposta.valorTotalFormatado" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.proposta.valorComissaoFormatado" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit',comissao)" :status="1" :value="comissao.proposta.formaPagamento == 0 ? '0' :comissao.proposta.formaPagamento" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.reComissaoParcela == 0 ? '0' :comissao.reComissaoParcela" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.reComissaoParcelaQuitada == 0 ? '0' :comissao.reComissaoParcelaQuitada" />
                  <TableColumn :IsActionsButtons="true" v-on:Delete ="$emit('deleteCommission', comissao.id)" :status="1" :HasChange = "false"/>
              </tr>
            </Tables>
</template>

<script>
import tableSales from './tableSales'
export default tableSales

</script>

<style scoped>

.scroll
{
  height: 640px;
  overflow: auto;
}

.Table-Info{
  width: 99%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/tableSales/tableSales.vue